import HttpClient from '../HttpService';

function getByRecord(recordUUID) {
    return HttpClient.get(`/records/${recordUUID}/conclusions`);
}

function generate(recordUUID, type = 'standard') {
    const endpoint = type === 'acia' ? 'acia' : 'conclusion';
    return HttpClient.post(`/records/${recordUUID}/${endpoint}`);
}

function updateText(conclusionUUID, textContent) {
    return HttpClient.put(`/conclusions/${conclusionUUID}`, {
        text_content: textContent
    });
}

// image: screenshot da matriz de risco, usada no relatório da avaliação que sai
// junto da conclusão no mesmo PDF.
function exportPdf(conclusionUUID, image = '') {
    return HttpClient.post(`/conclusions/${conclusionUUID}/export-pdf`, { image });
}

function downloadPdfUrl(conclusionUUID) {
    const base = process.env.VUE_APP_ROOT_API || '';
    return `${base}/conclusions/${conclusionUUID}/download-pdf`;
}

export default {
    getByRecord,
    generate,
    updateText,
    exportPdf,
    downloadPdfUrl
};
